// Spec §1: a fixed list the realtor picks from, plus free entries. Keep the
// wording exactly as buyers will read it on the card and the details table.
export const HOUSE_FEATURES = [
  'Borehole', 'Solar backup', 'Generator', 'Staff quarters', 'Swimming pool', 'Electric fence',
  'Durawall', 'Alarm', 'Fitted kitchen', 'Fitted wardrobes', 'Tiled roof', 'Thatch', 'Garden',
  'Fruit trees', 'Gate motor', 'Fibre internet', 'Council water', 'Sewer connected', 'Septic tank',
];

export const STAND_FEATURES = ['Serviced', 'Corner stand', 'Level', 'Walled', 'Council water', 'Sewer connected'];

export const featuresFor = (listingType) => (listingType === 'house' ? HOUSE_FEATURES : STAND_FEATURES);
